/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { ComponentChildren } from 'preact';

import { MenuValueUpdateDetail } from './menuUtils';
import { SelectMenuGroupContext } from './SelectMenuGroupContext';

type SelectSingleMenuGroupProps = {
  children: ComponentChildren;
  value?: string;
  onCommit?: (detail: MenuValueUpdateDetail<string>) => void;
  groupKey?: string;
};

export function SelectSingleMenuGroup({
  value,
  onCommit,
  children,
  groupKey
}: SelectSingleMenuGroupProps) {
  return (
    <SelectMenuGroupContext.Provider value={{ isMultiple: false, value, onCommit, groupKey }}>
      {children}
    </SelectMenuGroupContext.Provider>
  );
}
